An opaque cursor to the later bounding hirers.

Resulting hirers will be alphabetically earlier than this cursor.
